import { withInstall } from '@touchvue/utils'
import Param from './src/Param.vue'
import ParamItem from './src/ParamItem.vue'

export const ToParam = withInstall(Param, [ParamItem])
export default ToParam

export * from './src/param'
export * from './src/param-item'
